import {
  Avatar,
  Badge,
  Button,
  Card,
  Col,
  Dropdown,
  FloatButton,
  Image,
  Input,
  Layout,
  // List,
  Modal,
  Row,
  Space,
  Typography,
} from "antd";
import React from "react";
import {
  FacebookOutlined,
  InstagramOutlined,
  GlobalOutlined,
  ShoppingCartOutlined,
  DownOutlined,
  // SmileOutlined,
} from "@ant-design/icons";
import { useRef } from "react";
import { useState } from "react";
import axios from "axios";
import { useCallback } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomerOrderDialog from "./customer/CustomerOrderDialog";
import CustomerViewOrders from "./customer/CustomerViewOrders";
import { Content, Footer, Header } from "antd/es/layout/layout";
import Meta from "antd/es/card/Meta";

const CustomerOrdering = () => {
  const facebookButton = useRef();
  const websiteButton = useRef();
  const instaButton = useRef();
  const { merchant_id, merchant_uid } = useParams();
  const [storeInfo, setStoreInfo] = useState({
    data: [],
    ready: false,
  });
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const [categoryList, setCategoryList] = useState({
    data: [],
    ready: false,
  });
  const [orderList, setOrderList] = useState({
    data: [],
    ready: false,
  });
  const tranxID = localStorage.getItem("tranxID");
  const [selectedData, setSelectedData] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [totalCost, setTotalCost] = useState(0);
  const [search, setSearch] = useState("");
  const [openOrderDialog, setOpenOrderDialog] = useState(false);

  const getStoreInfo = useCallback(() => {
    var params = { merchant_id, merchant_uid };
    axios
      .get("customer/merchant-info", { params })
      .then((response) => {
        const data = response.data;
        setStoreInfo({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [merchant_id, merchant_uid]);

  const getAllProducts = useCallback(() => {
    var params = { merchant_id, merchant_uid };
    axios
      .get("customer/merchant-products", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [merchant_id, merchant_uid]);

  const getAllCategory = useCallback(() => {
    var params = { merchant_id, merchant_uid };
    axios
      .get("customer/merchant-category", { params })
      .then((response) => {
        const data = response.data;
        setCategoryList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [merchant_id, merchant_uid]);

  const getAllExistingOrder = useCallback(() => {
    var params = { transaction_id: tranxID };
    axios
      .get("customer/existing-order", { params })
      .then((response) => {
        const data = response.data;
        setOrderList({ data, ready: true });
        setTotalCost(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [tranxID]);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].quantity) * parseFloat(data[i].price);
    }
    return total;
  };

  useEffect(() => {
    getStoreInfo();
    getAllProducts();
    getAllCategory();
    getAllExistingOrder();
    if (tranxID === null) {
      localStorage.setItem("tranxID", Math.floor(Math.random() * 99999999) + 1);
    }
  }, [
    getStoreInfo,
    getAllProducts,
    getAllCategory,
    getAllExistingOrder,
    tranxID,
  ]);

  const searchable = productList.data.filter((data) => {
    return data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  const handleFetchByCategory = ({ key }) => {
    var params = { merchant_id, merchant_uid, id: key };
    axios
      .get("customer/merchant-products-filter-by-category", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  return (
    <>
      <Layout
        className="colorfulcontainer"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Header
          className="antdheader"
          style={{
            width: "100%",
            position: "inherit",
          }}
        >
          <div
            style={{
              display: "flex",
            }}
          >
            <div style={{ flexGrow: 1 }} />
            <div>
              <FacebookOutlined
                style={{ color: "#fff", cursor: "pointer" }}
                onClick={() => facebookButton.current.click()}
              />
            </div>
            <div>
              <InstagramOutlined
                style={{ color: "#fff", marginLeft: 20, cursor: "pointer" }}
                onClick={() => instaButton.current.click()}
              />
            </div>
            <div>
              <GlobalOutlined
                style={{ color: "#fff", marginLeft: 20, cursor: "pointer" }}
                onClick={() => websiteButton.current.click()}
              />
            </div>
          </div>
        </Header>
        <Content
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            paddingLeft: 10,
            paddingRight: 10,
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              maxWidth: 900,
              width: "100%",
              zIndex: 1,
            }}
          >
            {storeInfo.ready && (
              <Image
                width={"auto"}
                //  src={require("./../../assets/900x300logo.png")}
                src={
                  storeInfo.data[0].business_cover !== null
                    ? `${process.env.REACT_APP_API_IMAGE}cover/${storeInfo.data[0].business_cover}`
                    : require("./../../assets/900x300logo.png")
                }
                preview={false}
              />
            )}
          </div>

          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              maxWidth: 900,
              width: "100%",
              minHeight: 160,
              marginTop: -40,
              zIndex: 2,
              borderTopLeftRadius: 45,
              borderTopRightRadius: 45,
              backgroundColor: "#fff",
              padding: 20,
            }}
          >
            {storeInfo.ready && (
              <>
                <div
                  style={{
                    borderRadius: 75,
                    marginTop: -80,
                  }}
                >
                  <Avatar
                    size={150}
                    src={
                      storeInfo.data[0].business_logo !== null
                        ? `${process.env.REACT_APP_API_IMAGE}logo/${storeInfo.data[0].business_logo}`
                        : require("./../../assets/logo.png")
                    }
                  />
                </div>
                <Typography style={{ fontSize: 26, fontWeight: "bold" }}>
                  {storeInfo.data[0].business_name !== null
                    ? storeInfo.data[0].business_name
                    : ""}
                </Typography>
                <Typography.Text
                  style={{
                    fontSize: 15,
                    fontWeight: 500,
                    textTransform: "uppercase",
                    textAlign: "center",
                  }}
                >
                  {storeInfo.data[0].business_street !== null
                    ? `${storeInfo.data[0].business_street}, `
                    : ""}
                  {storeInfo.data[0].business_barangay !== null
                    ? `${storeInfo.data[0].business_barangay}, `
                    : ""}
                  {storeInfo.data[0].business_city !== null
                    ? `${storeInfo.data[0].business_city}, `
                    : ""}
                  {storeInfo.data[0].business_province !== null
                    ? `${storeInfo.data[0].business_province}`
                    : ""}
                </Typography.Text>
              </>
            )}
          </div>

          <div
            style={{
              position: "relative",
              maxWidth: 900,
              width: "100%",
              minHeight: 300,
              marginBottom: 10,
              borderBottomLeftRadius: 20,
              borderBottomRightRadius: 20,
              zIndex: 3,
            }}
          >
            <div
              style={{
                display: "flex",
                // justifyContent: "center",
                alignItems: "center",
                paddingLeft: 20,
                paddingRight: 20,
                paddingBottom: 10,
                backgroundColor: "#fff",
                marginBottom: window.innerWidth > 575 ? 10 : 0,
                borderBottomLeftRadius: window.innerWidth > 575 ? 10 : "",
                borderBottomRightRadius: window.innerWidth > 575 ? 10 : "",
                // border: "1px solid red",
              }}
            >
              {/* <div style={{ flexGrow: 1 }}> */}
              <Space direction="horizontal">
                {categoryList.ready && (
                  <Dropdown
                    menu={{
                      items: categoryList.data,
                      onClick: handleFetchByCategory,
                    }}
                  >
                    <Button
                      type="dashed"
                      shape="default"
                      // size="large"
                      size={50}
                      icon={<DownOutlined style={{ color: "#fff" }} />}
                      style={{
                        marginRight: 5,
                        // border: "2px solid #d15d46"
                        backgroundColor: "#d15d46",
                      }}
                    />
                  </Dropdown>
                )}

                <Input
                  placeholder="Search product"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    border: "2px solid #d15d46",
                    width:
                      window.innerWidth < 576 ? "calc(100vw - 108px)" : 300,
                    fontWeight: "bold",
                  }}
                  size="large"
                />
              </Space>
              {/* </div> */}
              {/* <Badge count={orderList.data.length} size="small">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setOpenDrawer(true);
                  }}
                  icon={<ShoppingCartOutlined style={{ color: "#fff" }} />}
                  style={{
                    marginLeft: 5,
                    // border: "2px solid #d15d46",
                    backgroundColor: "#d15d46",
                    // size: 40,
                  }}
                  size="large"
                />
              </Badge> */}
            </div>
            <div
              style={{
                padding: window.innerWidth > 575 ? 0 : 20,
                maxWidth: 900,
                width: "100%",
                borderBottomLeftRadius: 20,
                borderBottomRightRadius: 20,
                backgroundColor:
                  window.innerWidth > 575 ? "transparent" : "#fff",
              }}
            >
              {window.innerWidth > 575 ? (
                <Row>
                  {searchable.map((data, index) => (
                    <Col
                      key={index}
                      xs={24}
                      sm={12}
                      md={8}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Card
                        style={{
                          width: 260,
                          margin: 5,
                          boxShadow: "1px 2px 9px #AEAEAE",
                        }}
                        cover={
                          <Image
                            width={"100%"}
                            height={160}
                            src={
                              data.product_image !== null
                                ? `${process.env.REACT_APP_API_IMAGE}products/${data.product_image}`
                                : require("./../../assets/empty.png")
                            }
                            preview={true}
                          />
                        }
                      >
                        <Meta
                          title={data.product}
                          description={`P ${data.price}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSelectedData(data);
                            setOpenOrderDialog(data);
                          }}
                        />
                      </Card>
                    </Col>
                  ))}
                </Row>
              ) : (
                <>
                  {searchable.map((data, index) => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 5,
                        borderBottom: "0.5px dotted #e5e5e5",
                      }}
                      key={index}
                    >
                      <div
                        style={{
                          flexGrow: 1,
                          cursor: "pointer",
                          marginBottom: 10,
                          height: "100%",
                        }}
                        onClick={() => {
                          setSelectedData(data);
                          setOpenOrderDialog(data);
                        }}
                      >
                        <Typography style={{ fontWeight: "bold" }}>
                          {data.product}
                        </Typography>
                        <Typography> &#8369; {data.price}</Typography>
                      </div>
                      <div>
                        {data.product_image !== null ? (
                          <Image
                            width={81}
                            height={50}
                            src={
                              data.product_image !== null
                                ? `${process.env.REACT_APP_API_IMAGE}products/${data.product_image}`
                                : require("./../../assets/empty.png")
                            }
                            placeholder={"logo"}
                            preview={data.product_image !== null ? true : false}
                          />
                        ) : null}
                      </div>
                    </div>
                  ))}
                </>

                // <List
                //   itemLayout="vertical"
                //   // style={{ backgroundColor: "#fff" }}
                //   // size="large"
                //   // pagination={{
                //   //   onChange: (page) => {
                //   //     console.log("PAGE", page);
                //   //   },
                //   //   pageSize: 1,
                //   // }}
                //   dataSource={searchable}
                //   renderItem={(item) => (
                //     <>
                //       <List.Item
                //         style={{ cursor: "pointer" }}
                //         extra={
                //           item.product_image !== null ? (
                //             <Image
                //               width={"auto"}
                //               height={50}
                //               src={
                //                 item.product_image !== null
                //                   ? `${process.env.REACT_APP_API_IMAGE}products/${item.product_image}`
                //                   : require("./../../assets/empty.png")
                //               }
                //               placeholder={"logo"}
                //               preview={
                //                 item.product_image !== null ? true : false
                //               }
                //             />
                //           ) : null
                //         }
                //       >
                //         <List.Item.Meta
                //           onClick={() => {
                //             setSelectedData(item);
                //             setOpenOrderDialog(item);
                //           }}
                //           title={
                //             <Typography
                //               style={{
                //                 paddingLeft: 2,
                //                 paddingRight: 2,
                //               }}
                //             >
                //               {item.product}
                //             </Typography>
                //           }
                //           description={
                //             <Typography
                //               style={{
                //                 paddingLeft: 2,
                //                 paddingRight: 2,
                //               }}
                //             >
                //               &#8369; {item.price}
                //             </Typography>
                //           }
                //         />
                //       </List.Item>
                //     </>
                //   )}
                // />
              )}
            </div>
          </div>
        </Content>
        <Footer
          style={{
            textAlign: "center",
            fontWeight: "bold",
            width: "100%",
            position: "inherit",
            marginBottom: 0,
          }}
        >
          BBMS ©2023 Created by Nehemiah Solutions
        </Footer>

        <Button
          ref={facebookButton}
          style={{ display: "none" }}
          type="default"
          target="_blank"
          href="https://www.facebook.com/nehemiahsolutionsph"
        />
        <Button
          ref={instaButton}
          style={{ display: "none" }}
          type="default"
          target="_blank"
          href="https://www.instagram.com"
        />
        <Button
          ref={websiteButton}
          style={{ display: "none" }}
          type="default"
          target="_blank"
          href="https://www.nehemiahsolutions.com"
        />

        {orderList.data.length > 0 && (
          <FloatButton
            description={
              <div style={{ display: "flex", alignItems: "center" }}>
                <Badge
                  count={orderList.data.length}
                  size="small"
                  // style={{ marginRight: 10 }}
                >
                  <ShoppingCartOutlined style={{ fontSize: 20 }} />
                </Badge>

                <Typography style={{ fontSize: 16, marginLeft: 10 }}>
                  Total: &#8369;
                  {totalCost.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </div>
            }
            shape="square"
            style={{
              width: window.innerWidth > 575 ? 200 : window.innerWidth - 20,
              right: `10px`,
              border: "2px solid #d15d46",
            }}
            onClick={() => {
              setOpenDrawer(true);
            }}
          />
        )}
      </Layout>

      {openDrawer && (
        <CustomerViewOrders
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          getAllExistingOrder={() => getAllExistingOrder()}
          orderList={orderList.data}
          totalCost={totalCost}
        />
      )}

      <Modal
        title=""
        open={openOrderDialog}
        onCancel={() => setOpenOrderDialog(false)}
        footer={null}
        width={350}
      >
        <CustomerOrderDialog
          selectedData={selectedData}
          close={() => setOpenOrderDialog(false)}
          getAllExistingOrder={() => getAllExistingOrder()}
          merchant_id={merchant_id}
          totalCost={totalCost}
        />
      </Modal>
    </>
  );
};

export default CustomerOrdering;
